// routers
import LoginVue from './login/index.vue';
import MainVue from './main/index.vue';
import MainRouteMap from './main/route';
import Page404 from './404.vue';

export default {
  routes: [{
    path: '/logout',
    login: false,
    company: false,
    hidden: true,
  }, {
    name: '登录',
    path: '/login',
    login: false,
    company: false,
    component: LoginVue,
    hidden: true,
  }, {
    path: '/',
    login: true,
    company: true,
    component: MainVue,
    children: MainRouteMap,
    redirect: "/home",
  }, {
    path: '*',
    login: true,
    company: false,
    hidden: true,
    component: Page404,
  }],
};
